module.exports = __webpack_public_path__ + "media/images/social/instagram-2117577426648e06e17294ae312e0912.svg";